import {useEffect,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import useApiStatusDispatch from '../../../../hooks/useApiStatusDispatch'
import {
	useCreatePurchaseForm,
	useRemovePurchaseForm,
	usePurchaseItemForms,
	useMerchandiseEditor,
	useMerchandiseItem
} from '../../hooks'
import useDirectUpload from '../../../../hooks/useS3DirectUpload'
import {
	createMerchandiseItem,
	editMerchandiseItem,
	setEditor
} from '../merchandiseSlice'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import {selectAcceptedCurrency} from '../../../settings/settingsSlice'

import Select from 'react-select'

const Editor = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const { show, id } = useMerchandiseEditor()
	const {status,item} = useMerchandiseItem(id)
	const [title,setTitle] = useState('')
	const [description,setDesciption] = useState('')
	const [price,setPrice] = useState('')
	const [saveStatus,setSaveStatus] = useState('idle')
	const [active,setActive] = useState(1)
	const [previewSrc,setPreviewSrc] = useState('')

	const {file,processUpload,setUpload,clearUpload} = useDirectUpload()

	const {
		status:productFormsStatus,
		forms:productForms,
		allForms
	} = usePurchaseItemForms('merchandise',id)

	const createPurchaseForm = useCreatePurchaseForm()
	const removePurchaseForm = useRemovePurchaseForm()

	const acceptedCurrency = useSelector(selectAcceptedCurrency)

	useEffect(()=>{
		if(id&&item){
			setTitle(item.title)
			setDesciption(item.description)
			setPrice((item.unit_amount/100).toFixed(2))
			setPreviewSrc(item.attachment)
			setActive(item.active)
		}else{
			setPreviewSrc('')
			setTitle('')
			setDesciption('')
			setPrice('')
			clearUpload()
			setActive(1)
		}
	},[id])

	const handleToggleEditor = () => { 
		dispatch(setEditor({show:false,id:false}),{}) 
	}

	const handleSave = async ()=>{
		setSaveStatus('pending')
		const unit_amount = Math.round(parseFloat(price)*100)
		const isNew = !id
		//if item exists default attachment to the one that exists
		//otherwise default to empty string
		let attachment = previewSrc
		//if a new file is selected then upload it to S3 and set 
		//attachment to the new S3 url
		if(Boolean(file)){
			const {success,payload:{url}} = await processUpload()
			if(success) attachment = url
		}
		if(isNew){
			statusDispatch(createMerchandiseItem({
				unit_amount,
				price,
				description,
				attachment,
				active,
				title
			}),'merchandise item','create')
		}else{
			statusDispatch(editMerchandiseItem({
				id,
				update:{
					unit_amount,
					price,
					description,
					attachment,
					active,
					title,
				}
			}),'merchandise item','edit')
		}
		handleToggleEditor()
		setSaveStatus('idle')
		setTitle('')
		setDesciption('')
		clearUpload()
		setPreviewSrc('')
		setPrice('')
	}

	const handleFileSelect = e => {
		setUpload(e.target.files[0])
		setPreviewSrc(URL.createObjectURL(e.target.files[0]))
	}

	const handleClearUpload = ()=>{
		clearUpload()
		setPreviewSrc('')
	}

	return (
		<Modal show={show} onHide={handleToggleEditor}>
			<Modal.Header>Editor</Modal.Header>
			<Modal.Body>
				<label>Title</label>
				<Form.Control 
					onChange={ e => { setTitle(e.target.value) } }
					placeholder="title" 
					value={title}
				/>
				{Boolean(previewSrc)&&
					<div>
						<img style={{width:'100%',maxHeight:'200px',objectFit:'contain'}} src={previewSrc}/>
						<Button 
							variant="link"
							className="text-danger"
							size="sm"
							block
							onClick={handleClearUpload} 
							tabIndex={0}
						>
							remove
						</Button>
					</div>
				}
				<Form.File 
					id="merchandise-item-attachment-input"
					onChange={handleFileSelect}
					label="Optional Image"
					className="mt-2"
					key={previewSrc} // <=== REQUIRED to make clear work correctly
					custom
				/>
				<label>Description</label>
				<Form.Control 
					onChange={ e => { setDesciption(e.target.value) } }
					placeholder="description" 
					value={description}
				/>
				<label>Price</label>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text>
							{String.fromCharCode(acceptedCurrency?.char_code)}
						</InputGroup.Text>
					</InputGroup.Prepend>
					<Form.Control 
						onChange={ e => { setPrice(e.target.value) } }
						placeholder={`price (${acceptedCurrency.ISO})`}
						value={price}
					/>
				</InputGroup>
				<label>Linked Forms/Waivers (Optional)</label>
				<div>
					<Select 
						onChange={(_,payload)=>{
							switch(payload.action){
								case 'select-option':
									createPurchaseForm({
										itemType:'merchandise',
										itemId:id,
										formId:payload.option.value
									})
									break;
								case 'remove-value':
									removePurchaseForm({
										itemType:'merchandise',
										itemId:id,
										formId:payload.removedValue.value
									})
									break;
							}
						}}
						value={
							productForms.map(
								form => ({
									value:form.form_id,
									label:form.form_title
								})
							)//end map
						}
						options={
							allForms.map(
								form => ({
									value:form.form_id,
									label:form.form_title
								})
							)//end map
						}//end options
						isMulti
					/>
				</div>
				<div className="mt-2">
					<Form.Switch
						onChange={e=>{
							setActive(Number(e.target.checked))
						}}
						checked={active}
						id="merchandise-item-active-switch"
						label="Allow clients to purchase this item"
					/>
					<small className={active?'text-success':'text-danger'}>
						{active?'Purchases are active':'Purchases are NOT active'}
					</small>
				</div>
				<div className="mt-2 text-right">
					<Button 
						disabled={saveStatus==='pending'}
						variant="outline-success"
						onClick={handleSave}
						size="sm"
					>
						{
							saveStatus==='pending'?
							<span>
								Saving
								<Spinner className="ml-1" animation="border" size="sm"/>
							</span>
							:
							'Save'
						}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default Editor